import React from 'react';
import { useAppContext } from '../context/AppContext';
import { getNextTierInfo, getPricePerPixel } from '../utils/pricing';
import * as FiIcons from 'react-icons/fi';
const { FiZap, FiActivity, FiLogOut, FiUser, FiBarChart2, FiInfo, FiGrid, FiDollarSign } = FiIcons;

export default function Header() {
  const { pixelsSold, liveVisitors, setIsWelcomeModalOpen, user, setIsAuthModalOpen, setCurrentPage, signOut } = useAppContext();
  const nextTier = getNextTierInfo(pixelsSold);
  const currentPrice = getPricePerPixel(pixelsSold);
  const percentSold = ((pixelsSold / 1000000) * 100).toFixed(2);

  return (
    <div className="absolute top-0 left-0 right-0 z-20 flex flex-col pointer-events-none">
      {nextTier && (
        <div className="overflow-hidden pointer-events-auto" style={{ background: 'linear-gradient(90deg,#ff00cc,#cc00ff,#ff00cc)' }}>
          <div className="py-1.5 flex items-center gap-2 justify-center text-white font-black uppercase tracking-wider" style={{ fontSize: '12px' }}>
            <FiZap className="animate-blink shrink-0" />
            <span className="truncate px-1">⚡ {nextTier.remaining.toLocaleString()} px left at ${currentPrice.toFixed(2)}/px — next: ${nextTier.nextPrice.toFixed(2)}</span>
            <FiZap className="animate-blink shrink-0" />
          </div>
        </div>
      )}
      <div className="flex items-center justify-between px-3 py-2 pointer-events-auto"
        style={{ background: 'rgba(5,0,16,0.93)', backdropFilter: 'blur(20px)', borderBottom: '1px solid rgba(255,0,200,0.2)' }}>
        {/* Logo */}
        <button onClick={() => setIsWelcomeModalOpen(true)} className="flex items-center gap-2 hover:opacity-80 transition-opacity">
          <div className="w-7 h-7 rounded-lg flex items-center justify-center animate-pulse-pink" style={{ background: 'linear-gradient(135deg,#ff00cc,#cc00ff)' }}>
            <FiActivity className="text-white text-xs" />
          </div>
          <span className="font-black uppercase tracking-widest" style={{ color: '#ff00cc', fontFamily: 'Impact,sans-serif', fontSize: '15px' }}>1M PIXELS</span>
        </button>

        {/* Stats — desktop only */}
        <div className="hidden md:flex items-center gap-4">
          <div className="flex flex-col items-center px-3 border-r border-pink-500/20">
            <span className="text-gray-500 uppercase tracking-wider" style={{ fontSize: '11px' }}>Price</span>
            <span className="font-black text-white" style={{ fontSize: '15px' }}>${currentPrice.toFixed(2)}<span className="text-gray-500 font-normal" style={{ fontSize: '12px' }}>/px</span></span>
          </div>
          <div className="flex flex-col items-center px-3 border-r border-pink-500/20">
            <span className="text-gray-500 uppercase tracking-wider" style={{ fontSize: '11px' }}>Sold</span>
            <span className="font-black" style={{ color: '#ff00cc', fontSize: '15px' }}>{pixelsSold.toLocaleString()}</span>
          </div>
          <div className="flex flex-col items-center px-3">
            <span className="text-gray-500 uppercase tracking-wider" style={{ fontSize: '11px' }}>Live</span>
            <span className="font-black text-green-400 flex items-center gap-1" style={{ fontSize: '15px' }}>
              <span className="w-1.5 h-1.5 rounded-full bg-green-400 animate-blink" />{liveVisitors}
            </span>
          </div>
        </div>

        {/* Actions */}
        <div className="flex items-center gap-2">
          <button onClick={() => setCurrentPage('affiliate')}
            className="hidden md:flex items-center gap-1.5 px-3 py-1.5 rounded-lg font-black uppercase tracking-wider transition-all hover:scale-105"
            style={{ background: 'rgba(0,255,136,0.1)', border: '1px solid rgba(0,255,136,0.3)', color: '#00ff88', fontSize: '13px' }}>
            <FiDollarSign /> Earn 20%
          </button>
          <button onClick={() => setCurrentPage('rankings')}
            className="hidden md:flex items-center gap-1.5 px-3 py-1.5 rounded-lg font-black uppercase tracking-wider transition-all hover:text-pink-400"
            style={{ color: '#9ca3af', border: '1px solid rgba(255,255,255,0.08)', fontSize: '13px' }}>
            <FiBarChart2 /> Rankings
          </button>
          <button onClick={() => setCurrentPage('about')}
            className="hidden md:flex items-center gap-1.5 px-3 py-1.5 rounded-lg font-black uppercase tracking-wider transition-all hover:text-pink-400"
            style={{ color: '#9ca3af', border: '1px solid rgba(255,255,255,0.08)', fontSize: '13px' }}>
            <FiInfo /> About
          </button>
          {user ? (
            <div className="flex items-center gap-2">
              <button onClick={() => setCurrentPage('myblocks')}
                className="hidden md:flex items-center gap-1.5 px-3 py-1.5 rounded-lg font-black uppercase tracking-wider transition-all"
                style={{ background: 'rgba(255,0,200,0.1)', border: '1px solid rgba(255,0,200,0.3)', color: '#ff00cc', fontSize: '13px' }}>
                <FiGrid className="text-xs" />
                {user.user_metadata?.name || user.user_metadata?.full_name || user.email?.split('@')[0]}
              </button>
              <button onClick={signOut}
                className="hidden md:flex px-3 py-1.5 rounded-lg font-bold text-gray-400 hover:text-white transition-all items-center gap-1"
                style={{ border: '1px solid rgba(255,255,255,0.1)', fontSize: '13px' }}>
                <FiLogOut /> Sign Out
              </button>
              <button onClick={() => setCurrentPage('myblocks')}
                className="flex md:hidden w-7 h-7 rounded-full overflow-hidden border border-pink-500/40 items-center justify-center"
                style={{ background: 'rgba(255,0,200,0.1)' }}>
                {user.user_metadata?.avatar_url
                  ? <img src={user.user_metadata.avatar_url} alt="avatar" className="w-full h-full object-cover" />
                  : <FiUser className="text-pink-400 text-xs" />}
              </button>
            </div>
          ) : (
            <button onClick={() => setIsAuthModalOpen(true)}
              className="px-3 py-1.5 rounded-lg font-black uppercase tracking-widest text-white transition-all hover:scale-105 active:scale-95 animate-pulse-pink"
              style={{ background: 'linear-gradient(135deg,#ff00cc,#cc00ff)', fontFamily: 'Impact,sans-serif', letterSpacing: '1px', fontSize: '13px' }}>
              CLAIM
            </button>
          )}
        </div>
      </div>
      <div className="h-1 w-full bg-gray-900 pointer-events-none">
        <div className="h-full transition-all duration-1000" style={{ width: `${percentSold}%`, background: 'linear-gradient(90deg,#ff00cc,#cc00ff)' }} />
      </div>
    </div>
  );
}